module.exports = __webpack_public_path__ + "images/mangoes.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/fruit/mangoes.jpg
// module id = 167
// module chunks = 0